import { observer } from "mobx-react-lite";
import { Button } from "@/components/ui/button";
import { useTran } from "@/hooks";
import { customDisclosureStore } from "../../stores/custom-disclosure.store";

const DisclosurePagination = observer(() => {
  const { t } = useTran();
  const { disclosures, pagination, loadDisclosures } = customDisclosureStore;
  const { total, page: currentPage, totalPages } = pagination;

  if (totalPages <= 1) return null;

  return (
    <div className="flex items-center justify-between">
      <p className="text-sm text-muted-foreground">
        {t("Showing")} {disclosures.length} {t("of")} {total}
      </p>
      <div className="flex gap-2">
        <Button
          size="sm"
          variant="outline"
          disabled={currentPage === 1}
          onClick={() => loadDisclosures({ page: currentPage - 1 })}
        >
          {t("Previous")}
        </Button>
        <Button
          size="sm"
          variant="outline"
          disabled={currentPage === totalPages}
          onClick={() => loadDisclosures({ page: currentPage + 1 })}
        >
          {t("Next")}
        </Button>
      </div>
    </div>
  );
});

export default DisclosurePagination;
